<template>
  <v-dialog v-model="show" fullscreen persistent v-if="error">
            <v-card>
                <v-toolbar flat dense height="24px" class="pt-3"><v-spacer/><v-btn flat icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn></v-toolbar>
                <v-container fluid class="pt-0">
                    <v-row>
                        <v-col cols="12">
                            <v-list-item v-if="isMobile">
                                <v-list-item-content>
                                    <v-list-item-title v-if="error.code">{{ $t('triggersHistories.errorCode') }}:</v-list-item-title>
                                    <v-list-item-title v-if="error.code">{{ error.code }}</v-list-item-title>
                                    <v-list-item-title>{{ $t('triggersHistories.date') }}:</v-list-item-title>
                                    <v-list-item-title>{{ new Date(error.date) | moment("DD/MM/YYYY HH:mm:ss") }}</v-list-item-title>
                                    <v-list-item-title>{{ $t('triggersHistories.errorCallId') }}:</v-list-item-title>
                                    <v-list-item-title>{{ error.error_call_id }}</v-list-item-title>
                                    <v-list-item-title v-if="error.message" class="pt-4">{{ $t('triggersHistories.errorMessage') }}:</v-list-item-title>
                                    <v-textarea :class="isDark ? 'triggerHistoryTextAreaDark' : 'triggerHistoryTextArea'" v-if="error.message" v-model="error.message" dense readonly flat rows="5" hide-details="auto"/>
                                    <v-list-item-title v-if="error.details" class="pt-4">{{ $t('triggersHistories.errorDetails') }}:</v-list-item-title>
                                    <v-textarea :class="isDark ? 'triggerHistoryTextAreaDark' : 'triggerHistoryTextArea'" v-if="error.details" v-model="error.details" dense readonly flat rows="5" hide-details="auto"/>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-else>
                                <v-list-item-content>
                                    <v-list-item-title v-if="error.code">{{ $t('triggersHistories.errorCode') }}: {{ error.code }}</v-list-item-title>
                                    <v-list-item-title>
                                        {{ $t('triggersHistories.date') }}: {{ new Date(error.date) | moment("DD/MM/YYYY HH:mm:ss") }}
                                    </v-list-item-title>
                                    <v-list-item-title>{{ $t('triggersHistories.errorCallId') }}: {{ error.error_call_id }}</v-list-item-title>
                                    <v-list-item-title v-if="error.message" class="pt-4">{{ $t('triggersHistories.errorMessage') }}: </v-list-item-title>
                                    <v-textarea :class="isDark ? 'triggerHistoryTextAreaDark' : 'triggerHistoryTextArea'" v-if="error.message" v-model="error.message" dense readonly flat rows="5" hide-details="auto"/>
                                    <v-list-item-title v-if="error.details" class="pt-4">{{ $t('triggersHistories.errorDetails') }}: </v-list-item-title>
                                    <v-textarea :class="isDark ? 'triggerHistoryTextAreaDark' : 'triggerHistoryTextArea'" v-if="error.details" v-model="error.details" dense readonly flat rows="5" hide-details="auto"/>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-btn color="secondary" tile flat @click="$emit('close')">{{$t('triggersHistories.close')}}</v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
</template>


<script>
import { mapState } from 'vuex'
export default {
    name: "ErrorDetailsDialog",
    props: {
        error: {
            type: Object,
            default: function(){
                return {}
            } 
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        },
        isMobile () {
            return this.$vuetify.breakpoint.width < 450
        },
        ...mapState(['isDark']),
    },
};
</script>
<style scoped>
    .w-45 {
        width: 45%;
    }
</style>